export default "__VITE_ASSET__CHYk8G6$__"